import React from 'react';


class SettingsHeader extends React.Component {

    render () {
        return (
            <header className="settings-header">
                <div className="maxwidth-wrapper">
                    <h1 className="page-title">Settings</h1>
                </div>
            </header>
        );
    }
}

export default SettingsHeader;



/** WEBPACK FOOTER **
 ** ./app/src/components/SettingsHeader.js
 **/